const SIZES_MAP = [
  { us: '6', eu: '37', uk: '4' },
  { us: '6.5', eu: '37.5', uk: '4.5' },
  { us: '7', eu: '38', uk: '5' },
  { us: '7.5', eu: '38.5', uk: '5.5' },
  { us: '8', eu: '39', uk: '6' },
  { us: '8.5', eu: '39.5', uk: '6.5' },
  { us: '9', eu: '40', uk: '7' },
  { us: '9.5', eu: '40.5', uk: '7.5' },
  { us: '10', eu: '41', uk: '8' },
  { us: '10.5', eu: '41.5', uk: '8.5' },
  { us: '11', eu: '42', uk: '9' },
  { us: '11.5', eu: '42.5', uk: '9.5' },
  { us: '12', eu: '43', uk: '10' },
  { us: '12.5', eu: '43.5', uk: '10.5' },
  { us: '13', eu: '44', uk: '11' },
];

const SIZE_UNITS = ['us', 'uk', 'eu'];
const SIZE_REGEX = /(\w{2})\s?(\d+(?:\.\d)?)(\w+)?/;
const STORAGE_KEY = 'preferred_size_unit';

const EU_COUNTRIES = [
  'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR',
  'DE','GR','HU','IE','IT','LV','LT','LU','MT','NL',
  'PL','PT','RO','SK','SI','ES','SE','IS','NO','CH'
];

function detectSizeUnit(countryIso) {
  if (countryIso === 'GB') return 'uk';
  if (EU_COUNTRIES.includes(countryIso)) return 'eu';
  return 'us';
}

console.log('SizeUnitPicker loaded');

class SizeUnitPicker extends HTMLElement {
  connectedCallback() {
    console.log('SizeUnitPicker connected');
    this.select = this._createSelect();
    this._mountSelect();

    this.select.addEventListener('change', () => {
      this._setSizeUnit(this.select.value);
    });

    this._resolveInitialUnit().then((unit) => {
      this._setSizeUnit(unit);
      this.select.style.display = '';
    });
  }

  _createSelect() {
    const select = document.createElement('select');
    select.className = 'size-unit-select';
    select.style.display = 'none';
    select.style.marginLeft = '8px';
    SIZE_UNITS.forEach(function (unit) {
      const opt = document.createElement('option');
      opt.value = unit;
      opt.textContent = unit.toUpperCase();
      select.appendChild(opt);
    });
    return select;
  }

  _mountSelect() {
    const optionInfo = this.querySelector('.product-form__option-info');
    if (!optionInfo) return;

    const optionName = optionInfo.querySelector('.product-form__option-name');
    if (optionName) optionName.after(this.select);
    else optionInfo.prepend(this.select);

    const optionValue = optionInfo.querySelector('.product-form__option-value');
    if (optionValue) optionValue.style.display = 'none';
  }

  _setSizeUnit(unit) {
    this.sizeUnit = unit;
    this.select.value = unit;
    this._updateLabels(unit);

    try { localStorage.setItem(STORAGE_KEY, unit); } catch (e) {}
  }

  _updateLabels(unit) {
    this.querySelectorAll('input[type="radio"]').forEach(function (input) {
      const match = input.value.match(SIZE_REGEX);
      if (!match) return;

      const entry = SIZES_MAP.find(function (item) { return item.us === match[2]; });
      if (!entry) return;

      const label = input.nextElementSibling;
      if (label) {
        label.textContent = label.textContent.replace(SIZE_REGEX, function (_m, _u, _s, width) {
          return unit.toUpperCase() + ' ' + entry[unit] + (width || '');
        });
      }
    });
  }

  _resolveInitialUnit() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SIZE_UNITS.includes(stored)) {
      return Promise.resolve(stored);
    }

    return fetch('/browsing_context_suggestions.json')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        return detectSizeUnit(data.detected_values.country.handle);
      })
      .catch(function () {
        return 'us';
      });
  }
}

customElements.define('size-unit-picker', SizeUnitPicker);
